/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_ProfileInputs */

const en_common_nav_profile = /** @type {(inputs: Common_Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const zh_common_nav_profile = /** @type {(inputs: Common_Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Common_Nav_ProfileInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_nav_profile = /** @type {((inputs?: Common_Nav_ProfileInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_ProfileInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_nav_profile(inputs)
	return zh_common_nav_profile(inputs)
});
export { common_nav_profile as "common.nav.profile" }